import React from "react";
import PropTypes from "prop-types";
import { Datagrid, translate, ListContextProvider } from "react-admin";
import GroupingDatagridBody from "../GroupingDataGrid/GroupingDataGridBody";
import {
  MaterialColumn,
  ActionColumn,
  PreviewColumn,
  GroupedColumn,
  PriceColumn,
  IndexColumn,
} from "../TableColumns/TableColumns";
import DetailsColumn from "../TableColumns/DetailsColumn";
import SubtaskPanel from "../subtasks/panel/SubtaskPanel";
import SubtaskTypes from "../../config/SubtaskTypes";

const ArchivedModelDatagrid = ({ base, permissions, paymentComplete, ...props }) => (
  <ListContextProvider value={props}>
    <Datagrid {...props} body={<GroupingDatagridBody groupBy={["materialId"]} />} hover={false}>
      <MaterialColumn
        label="Material"
        sortBy="materialId"
        paymentComplete={paymentComplete}
        permissions={permissions}
        showAssignButton={false}
      />
      <IndexColumn label="Modell-Nr." />
      <PreviewColumn label="Vorschau" permissions={permissions} />
      <GroupedColumn label="Details">
        <DetailsColumn row={1} />
        <PriceColumn row={1} />
        <SubtaskPanel row={2} type={SubtaskTypes.MODEL.key} base={base} showAddTaskButton={false} />
      </GroupedColumn>
      <ActionColumn label="Aktion" paymentComplete={paymentComplete} permissions={permissions} isArchiveView={true} />
    </Datagrid>
  </ListContextProvider>
);

ArchivedModelDatagrid.propTypes = {
  base: PropTypes.string,
  permissions: PropTypes.object,
  paymentComplete: PropTypes.bool.isRequired,
};

ArchivedModelDatagrid.defaultProps = {
  paymentComplete: false,
};

export default translate(ArchivedModelDatagrid);
